module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/af02bfe244cded0b63202aa8d0a6ae5a.png";